<template>
  <div class="AnswerKeyH5">
    <div class="AnswerContainer" v-show="!ShowQrcode">
      <!-- <TopNavBar navtitle="听力考级"></TopNavBar> -->
      <van-tabs
        class="answerTitle"
        v-model="active"
        animated
        swipe-threshold="5"
        v-if="Question && Question.QuestionInfoList"
      >
        <van-tab
          v-for="(item, index) in Question.QuestionInfoList"
          :key="index"
          :title="
            `题目${index + 1}${
              item.result || item.result == 0 ? '(已答题)' : ''
            }`
          "
        >
          <div class="answerItem">
            <h1>
              {{ index + 1 }}-{{ item.TypeInfo.Type_Name }} ({{ item.Score }}分)
              <img
                v-if="!ReadTopic"
                src="@/assets/playsounde.png"
                width="20px"
                height="20px"
                alt=""
                @click="playText(item.TypeInfo.Type_Name)"
              />
              <img
                src="@/assets/playsoundc.gif"
                v-if="ReadTopic"
                width="20px"
                height="20px"
                alt=""
                @click="StopPlayText"
              />
            </h1>
            <h2
              class="ansimg"
              v-for="(qitme, qindex) in JSON.parse(item.Question)"
              :key="qindex"
            >
              <span v-if="qitme.T == 1">{{ qitme.Q }}</span>
              <img :src="qitme.Q" v-if="qitme.T == 2" />
              <audio :src="qitme.Q" v-if="qitme.T == 3" />
            </h2>
            <div class="answerOption">
              <van-radio-group
                v-model="item.result"
                direction="horizontal"
                v-if="item.TypeInfo.AnsweringMethod == 1"
              >
                <van-radio
                  :name="aindex"
                  v-for="(aitem, aindex) in JSON.parse(item.Options)"
                  :key="aindex"
                  ><img
                    v-if="item.QuestionType == 2"
                    :src="aitem"
                    alt=""
                  /><span v-if="item.QuestionType == 1">{{
                    aitem
                  }}</span></van-radio
                >
              </van-radio-group>
              <!-- 开始录音 -->
              <div class="recorditem" v-if="item.TypeInfo.AnsweringMethod == 2">
                <div class="recordflag">
                  <van-button
                    plain
                    hairline
                    type="info"
                    v-if="isRecord == false"
                    @click="startRD(item)"
                  >
                    <img src="@/assets/voicetubew.png" alt="" />
                    <p>点击答题</p>
                  </van-button>
                  <van-button
                    plain
                    hairline
                    type="info"
                    v-if="isRecord == true"
                    @click="startRD(item)"
                  >
                    <img src="@/assets/voicew.gif" alt="" />
                    <p>结束答题</p>
                  </van-button>
                </div>

                <div class="recordlist" v-if="item.result">
                  <van-radio-group v-model="radio">
                    <span>我的答题：</span>
                    <van-radio name="1" @click="playAnswert(item.result)">
                      <img
                        src="@/assets/playsounde.png"
                        alt=""
                        v-if="!item.result.play"
                      />
                      <img
                        src="@/assets/playsoundc.gif"
                        alt=""
                        v-if="item.result.play"
                      />
                      {{ item.result.time + "秒" }}
                    </van-radio>
                  </van-radio-group>
                </div>
              </div>
            </div>
            <!--倒计时 标准音 听题 交卷按钮 -->
            <div class="FootBtnbox item">
              <div class="statusBar">
                <ul>
                  <li
                    @click="wholetone(item)"
                    v-if="
                      JSON.parse(item.Question).filter(s => s.T == 3).length > 0
                    "
                  >
                    <img
                      src="@/assets/wholetone.png"
                      v-if="wtflag == false"
                      alt=""
                    />
                    <img
                      src="@/assets/wholetone.gif"
                      v-if="wtflag == true"
                      alt=""
                    />
                    <p v-if="wtflag == false">听题</p>
                    <p v-if="wtflag == true">听题</p>
                  </li>
                  <li v-if="index + 1 == Question.QuestionInfoList.length">
                    <van-button
                      type="danger"
                      @click="subBtn()"
                      class="submitExam"
                      round
                      >确认交卷</van-button
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </van-tab>
      </van-tabs>
      <!-- 答题结束弹框 -->
      <!-- <div @click="dialogVisible = true">
        答题时间结束弹出警示框
      </div> -->
      <!--倒计时 标准音 听题 交卷按钮 -->
      <div class="FootBtnbox">
        <div class="statusBar">
          <ul>
            <li v-if="time > 0">
              <img src="@/assets/countdown.png" alt="" />
              <van-count-down
                :time="time"
                ref="countDown"
                @finish="endAnswer"
              />
            </li>
            <li @click="atnote">
              <div :class="flag ? 'atnote' : ''">
                <img src="@/assets/note.png" alt="" />
              </div>
              <p v-if="flag == false">标准音</p>
              <p v-if="flag == true">标准音</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <van-overlay
      :show="ShowQrcode"
      style="background-color: rgba(0, 0, 0, 0.9)"
    >
      <div class="wrapper">
        <div class="block" v-if="QrCodeState == 2">
          <p>摄像头和麦克风开启失败，请检查摄像头是否可用！</p>
          <p>
            苹果手机用户可使用系统自带浏览器进行操作。操作方式:点击黔音在线—考级报名—右上角下拉菜单—选择在safari中打开。
          </p>
        </div>
        <div class="block" v-if="QrCodeState == 0">
          <div v-if="qrOption.text" v-qr="qrOption"></div>
          <br />

          请使用视频录制设备扫描该二维码
          <br />
          <van-button
            type="warning"
            @click="RelinkM()"
            v-if="Relink && QRCode != ''"
            >重新连接</van-button
          >
        </div>
        <div class="startbox" style="background: white" v-if="QrCodeState == 1">
          <van-icon name="checked" /> 与视频录制设备连线成功
          <br />
          <van-button type="primary" @click="Start">开始考试</van-button>
        </div>
      </div>
    </van-overlay>
    <audio id="playText" src="" style="dispaly: none"></audio>
    <audio id="answer" src="" style="dispaly: none"></audio>
    <audio id="wholetone" style="display: none"></audio>
    <audio
      src="@/assets/StandardPitch.mp3"
      id="StandardPitch"
      style="display: none"
    ></audio>

    <van-overlay :show="showSub">
      <van-loading size="24px">正在提交答题记录，请勿操作...</van-loading>
    </van-overlay>
  </div>
</template>
<script>
import TopNavBar from "@/components/TopNavBar.vue";
import signalInfo from "@u/signalR.js";
import {
  CreateAnswerRecord,
  StartExam,
  SubAnswers
} from "@/api/musictheory.js";
import { Dialog } from "vant";
import RecordRTC from "recordrtc";
import { WebMUpload } from "@/api/public";
export default {
  components: {
    TopNavBar
  },
  data() {
    return {
      active: 0,
      time: 0,
      radio: "1",
      flag: false,
      wtflag: false,
      isRecord: false,
      isPopup: false,
      playtxt: "播放",
      ShowQrcode: true,
      qrOption: { text: "", width: 250, height: 250 },
      QRCode: "",
      EF_ID: 0,
      IsTest: 1,
      QrCodeState: 0,
      signal: null,
      FileName: "",
      Question: null,
      ReadTopic: false,
      MediaSource: null,
      recorder: null,
      startTime: null,
      showSub: false,
      Relink: true,
      Name: "",
      ExamNo: "",
      GradeName: "",
      IsSubmit: false,
      clientId: ""
    };
  },
  mounted() {
    if (this.$route.query.EF_ID != undefined && this.$route.query.EF_ID > 0) {
      this.EF_ID = this.$route.query.EF_ID;
      let ID = this.EF_ID;
      let that = this;
      this.IsTest =
        this.$route.query.IsTest && this.$route.query.IsTest != 1 ? 0 : 1;

      if (window.stream) {
        window.stream.getTracks().forEach(track => {
          track.stop();
        });
      }
      if (!navigator.mediaDevices) {
        this.$toast.fail("摄像头和麦克风开启失败，请检查摄像头是否可用！");
        this.QrCodeState = 2;
        return;
      }
      // H5调用电脑摄像头API
      navigator.mediaDevices
        .getUserMedia({
          video: {
            width: { max: 1280 },
            height: { max: 720 }
            //facingMode: { exact: "environment" },
          },
          audio: true
        })
        .then(success => {
          that.MediaSource = success;
          Dialog.alert({
            title: "重要提示",
            message: `${
              this.IsTest == 0
                ? `<p>考试必须在规定时间内完成，每个考生只有三次机会，请勿随意尝试</p>`
                : "<p>每个考生每天只有十次练习机会</p>"
            }
                <p>1、为确保考试的正常进行，尽量确保考试手机和录制视频手机的网络状况良好，如果使用WIFI连接，尽量确保除考试使用的设备外，无其他设备连接，如果使用移动网络，请找信号良好的地方进行考试</p>
<p>2、因苹果设备的特殊性，需将系统更新至最新版本（14.4）方能进行考试</p>
<p>3、请从《黔音在线》官方公众号下方的等级考试菜单进入考试系统，不要从之前保存的链接，或收藏的链接进入</p>
<p>4、如果答题使用的手机在考试结束后提示提交失败，请等待系统自动提交，如果尝试提交多次，仍然失败，请更换到网络较好的环境，刷新页面重新答题</p>
<p>5、录制监考视频的手机会全自动进行操作，考试无需手工操作，请确保该手机网络状况，答题结束提交答案后，该手机会自动上传视频，该过程的时间长短取决于当前网络状况、答题时长、设备录制视频的大小有关，请耐心等待</p>
                `,
            beforeClose(action, done) {
              if (action === "confirm") {
                CreateAnswerRecord({ EF_ID: ID, IsTest: that.IsTest })
                  .then(res => {
                    console.log(res);
                    that.Question = res.item;
                    that.ShowQrcode = true;
                    that.QRCode = res.OtherMsg.QRCode;
                    that.FileName = res.item.FileName;
                    that.Name = encodeURI(res.OtherMsg.Name);
                    that.ExamNo = res.OtherMsg.ExamNo;
                    that.GradeName = encodeURI(res.OtherMsg.GradeName);
                    that.ConnectServer();
                    done();
                  })
                  .catch(() => {
                    setTimeout(() => location.reload(), 5000);
                  });
              } else {
                done(false);
              }
            }
          });
        })
        .catch(error => {
          this.$toast.fail("摄像头和麦克风开启失败，请检查摄像头是否可用！");
          this.QrCodeState = 2;
          return;
        });
    } else {
      this.$router.push("/ExamList");
    }
  },
  methods: {
    RelinkM() {
      if (this.Relink) {
        this.signal.invoke("AddToGroup", this.QRCode);
      }
    },
    beforeChangeQuestion() {
      if (this.isRecord == true) {
        this.$toast.fail("正在答题，请点击结束答题按钮停止录音");
        return;
      }
      return new Promise(resolve => {
        // 在 resolve 函数中返回 true 或 false
        resolve(true);
      });
    },
    ConnectServer() {
      console.log("开始连接");
      this.signal = signalInfo.createNew(this.QRCode);
      this.signal
        .start()
        .then(result => {
          console.log("this.QRCode :>> ", this.QRCode);
          this.signal.invoke("AddToGroup", this.QRCode);
          this.signal.invoke("GroupMessage", "Exam", "Relink", this.QRCode); //开始考试
          console.log("连接成功");
        })
        .catch(err => {
          console.log(err);
          this.$toast.fail("连接服务器失败，请稍后再试");
        });
      this.signal.on("GroupMessage", (user, message, GroupName) => {
        console.log("user :>> ", user);
        console.log("message :>> ", message);

        switch (message) {
          case "connection":
            this.QrCodeState = 1;
            this.clientId = user;
            break;
          case "Relink":
            this.Relink = false;
            break;
          default:
            break;
        }
      });
      this.signal.on("ConnectionId", (user, message) => {
        this.qrOption.text = `https://gzma.gzwcit.cn/downAPP.html?Context=${this.QRCode}&MasterConnectionId=${message}&FileName=${this.FileName}&IsTest=${this.IsTest}&EF_ID=${this.EF_ID}&Name=${this.Name}&ExamNo=${this.ExamNo}&GradeName=${this.GradeName}`;
        console.log("this.qrOption.text :>> ", this.qrOption.text);
      });
      let that = this;
      this.signal.on("BroadcastMessage", (user, message) => {
        console.log("user :>> ", user);
        console.log("message :>> ", message);
        switch (message) {
          case "Offline":
            console.log("this.clientId :>> ", this.clientId);
            console.log("user :>> ", user);
            if (this.clientId == user && this.IsSubmit) {
              return;
            }
            // that.$dialog
            //   .alert({
            //     title: '提示',
            //     message: '监考端APP已离线，请重新参加考试',
            //   })
            //   .then(() => {
            //     // on close
            //     that.$router.push('/ExamList');
            //   });
            break;
          default:
            break;
        }
      });
    },
    Start() {
      StartExam({ EML_ID: this.Question.EML_ID })
        .then(result => {
          this.ShowQrcode = false;
          this.signal.invoke("GroupMessage", "Exam", "Start", this.QRCode); //开始考试
          this.time = result.OtherMsg.TimeSpan;
        })
        .catch(err => {
          console.log(err);
          this.$toast.fail("开始考试操作失败，请稍后再试");
        });
    },
    atnote() {
      this.flag = true;
      let that = this;
      let StandardPitch = document.getElementById("StandardPitch");
      StandardPitch.play();
      StandardPitch.addEventListener(
        "ended",
        function() {
          that.flag = false;
        },
        false
      );
    },

    wholetone(obj) {
      let question = JSON.parse(obj.Question).filter(s => s.T == 3);
      if (question && question.length > 0) {
        if (obj.PayNum && obj.PayNum > 2) {
          this.$toast.fail("音频最多只能听三遍");
          return;
        }
        if (!obj.PayNum) {
          obj.PayNum = 0;
        }
        this.wtflag = !this.wtflag;
        this.flag = false;
        let wholetone = document.getElementById("wholetone");
        if (this.wtflag) {
          obj.PayNum++;
          wholetone.src = question[0].Q[0];
          wholetone.play();
        } else {
          wholetone.pause();
        }
        let that = this;
        wholetone.addEventListener(
          "ended",
          function() {
            that.wtflag = false;
          },
          false
        );
      } else {
        this.$toast.fail("该题目没有音频文件");
        return;
      }
    },
    startRD(item) {
      if (this.isRecord) {
        if (this.recorder) {
          this.recorder.stopRecording(audioURL => {
            this.$set(item, "result", {
              url: audioURL,
              item: this.recorder.getBlob(),
              time: (new Date() - this.startTime) / 1000,
              play: false
            });
          });
        } else {
          alert("请重新答题");
          this.isRecord = false;
        }
        console.log("停止答题");
      } else {
        this.recorder = RecordRTC(this.MediaSource, {
          type: "audio"
        });
        this.recorder.startRecording();
        this.startTime = new Date();
        console.log("开始答题");
      }
      this.isRecord = !this.isRecord;
    },
    subBtn() {
      debugger;
      Dialog.confirm({
        title: "提交答案",
        message: "确定要提交答案吗？"
      })
        .then(() => {
          this.submitExam(true);
        })
        .catch(() => {
          done();
        });
    },

    submitExam(verify) {
      // 结束考试，提交答案
      if (
        verify &&
        this.Question.QuestionInfoList.filter(s => s.result == undefined)
          .length > 0
      ) {
        this.$toast.fail("请完成所有考试内容");
        return;
      }
      this.IsSubmit = true;
      this.signal.invoke("GroupMessage", "Exam", "End", this.QRCode); //结束考试
      let AnswerInfo = [];
      let that = this;
      this.Question.QuestionInfoList.forEach(element => {
        if (element.result || element.result == 0) {
          if (element.TypeInfo.AnsweringMethod == 2) {
            // 问答题
            // 上传音频文件
            this.uploadFile(element).then(res => {
              AnswerInfo.push({
                EMQ_ID: element.EMQ_ID,
                Answer: res
              });
              if (AnswerInfo.length == that.Question.QuestionInfoList.length) {
                that.Question.AnswerInfo = JSON.stringify(AnswerInfo);
                that.SubAnswers();
              }
            });
          } else {
            AnswerInfo.push({ EMQ_ID: element.EMQ_ID, Answer: element.result });
          }
        } else {
          AnswerInfo.push({ EMQ_ID: element.EMQ_ID, Answer: "" });
        }
        if (AnswerInfo.length == that.Question.QuestionInfoList.length) {
          that.Question.AnswerInfo = JSON.stringify(AnswerInfo);
          that.SubAnswers();
        }
      });
    },

    SubAnswers() {
      this.showSub = true;
      let that = this;
      if (this.Question != null) {
        SubAnswers({
          EML_ID: this.Question.EML_ID,
          AnswerInfo: this.Question.AnswerInfo
        })
          .then(result => {
            that.$toast.success("提交成功，您已经完成考试，即将跳转到首页");
            setTimeout(() => {
              that.$router.push("/");
            }, 5000);
          })
          .catch(err => {
            that.$toast.success("提交失败，即将执行重新提交，请勿操作");
            setTimeout(() => {
              that.SubAnswers();
            }, 5000);
          });
      } else {
        this.$toast.fail("答题信息不正确");
      }
    },

    async uploadFile(blob) {
      blob.result.url = "";
      // const files = new window.File(
      //   [blob.result.item],
      //   `${this.Question.EML_ID}_${blob.EMQ_ID}.${
      //     blob.result.item.type.split('/')[1]
      //   }`,
      //   {
      //     type: blob.result.item.type,
      //   }
      // );
      const files = blob.result.item;
      let data = new FormData();
      data.append("file", files);
      await WebMUpload(data, { TypePath: "UserRecord" }).then(res => {
        blob.result.url = res.OtherMsg.FilePath;
      });
      return blob.result.url;
    },
    endAnswer() {
      Dialog.alert({
        message: "考试时间到，请停止作答并交卷",
        theme: "round-button"
      }).then(() => {
        this.submitExam(false);
      });
    },
    playText(text) {
      let that = this;
      this.ReadTopic = true;
      let ptext = document.getElementById("playText");
      ptext.src = `https://tts.baidu.com/text2audio?cuid=maple&lan=ZH&ctp=2&pdt=301&vol=9&rate=32&per=0&tex=${text}`;
      ptext.play();
      ptext.addEventListener(
        "ended",
        function() {
          that.ReadTopic = false;
        },
        false
      );
    },
    StopPlayText() {
      let ptext = document.getElementById("playText");
      ptext.pause();
      this.ReadTopic = false;
    },
    playAnswert(answer) {
      let that = this;
      if (!answer.play) {
        //播放
        answer.play = true;
        let an = document.getElementById("answer");
        an.src = answer.url;
        an.play();
        an.addEventListener(
          "ended",
          function() {
            answer.play = false;
          },
          false
        );
      } else {
        //停止播放
        document.getElementById("answer").pause();
        answer.play = false;
      }
    }
  }
};
</script>
<style>
.AnswerKey {
  background: #fff7ec;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
}
.AnswerKeyH5 {
  background: url("../../assets/hearinggreenbg.jpg") repeat-y;
  background-size: cover;
  /*  background:linear-gradient(to bottom,#fff7ec,#ffdac7); */
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  width: 100vh;
  height: 100vw;
  transform: translate(100vw) rotate(90deg);
  transform-origin: 0 0;
}
body,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
p,
blockquote,
dl,
dt,
dd,
ul,
ol,
li,
pre,
form,
fieldset,
legend,
button,
input,
textarea,
th,
td {
  font-size: 14px;
  width: 100%;
  height: 100%;
}
.AnswerContainer {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  width: 100%;
  position: relative;
  z-index: 1;
  overflow: hidden;
}
.answerTitle {
  position: relative;
}
.AnswerContainer .answerTitle .van-tabs__wrap {
  height: 35px;
}
.answerTitle .van-tabs__wrap .van-tabs__nav {
  background: rgba(0, 0, 0, 0.8);
}
.answerTitle .van-tabs__wrap .van-tabs__nav .van-tab__text {
  color: #fff;
}
.answerTitle .van-tabs__wrap .van-tabs__nav .van-tab--active .van-tab__text {
  background: linear-gradient(to bottom, #fa6779, #f05b6d);
  color: #fff;
  border-radius: 30px;
  border: solid 1px #fff;
  padding: 3px 10px;
  width: auto;
}

.answerTitle .van-tabs__wrap .van-tabs__nav .van-tabs__line {
  background-color: #fff;
  display: none;
}
.answerItem {
  width: 100%;
  position: relative;
  padding: 1%;
  box-sizing: border-box;
  margin: 0 auto;
}
.answerItem .item {
  top: 130px;
}
.answerItem .ansimg {
  text-align: left;
}
.answerItem .ansimg img {
  max-width: 80%;
  margin: 10px 0;
  max-height: 100px;
}
.answerItem h1 {
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  margin: 5px 0;
  display: flex;
  align-items: center;
}
.answerItem h1 img {
  margin-left: 5px;
}
.answerOption {
  padding: 1%;
  box-sizing: border-box;
  border-radius: 5px;
  min-height: 300px;
}
.answerOption .van-radio-group .van-radio .van-radio__label {
  margin-left: 3px;
  text-align: left;
  line-height: normal;
  padding: 1%;
}
.answerOption .van-radio-group .van-radio .van-radio__label img {
  width: 100%;
  max-height: 80px;
}
.answerOption .van-radio-group--horizontal .van-radio--horizontal {
  width: 40%;
  margin: 1%;
}
.answerOption
  .van-radio-group--horizontal
  .van-radio--horizontal
  .van-radio__icon
  .van-icon {
  border: solid 1px #fff;
}
.answerOption
  .van-radio-group--horizontal
  .van-radio--horizontal
  .van-radio__icon--checked
  .van-icon,
.recordlist .van-radio-group .van-radio .van-radio__icon--checked .van-icon {
  background: #f05b6d;
  border: solid 1px #fff;
}
.FootBtnbox {
  padding: 2px 0;
  position: absolute;
  top: 50px;
  right: 0;
  width: 100px;
  height: auto;
  z-index: 99;
}
.FootBtnbox ul li {
  margin: 10px auto;
}
.FootBtnbox ul li .van-button {
  width: 70px;
  height: 70px;
  background: #f05b6d;
  border-radius: 38px;
  margin: 20px 5px;
}
.FootBtnbox ul li .statusBar {
  background: #fff;
}
.FootBtnbox .statusBar ul li img {
  height: 20px;
  width: 20px;
}
.FootBtnbox .statusBar ul li .atnote {
  height: 26px;
  width: 26px;
  border-radius: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffb227;
  margin: 0 auto;
  animation: magnify 5s infinite linear;
}
@keyframes magnify {
  0% {
    transform: rotate(0deg);
    opacity: 0.9;
  }
  50% {
    transform: rotate(180deg);
    opacity: 1;
    background: #ffb227;
  }
  100% {
    transform: rotate(360deg);
    opacity: 0.9;
  }
}
.recordflag .van-button--info {
  text-align: center;
  display: inline-block;
  border-radius: 50px;
  height: 90px;
  width: 90px;
  background: linear-gradient(to bottom, #f05c6e, #fdb507);
  color: #fff;
  border: 2px solid #fff;
  margin: 2px;
}
.van-hairline--surround::after {
  border-width: 0;
}
.recordflag .van-button .van-button__content .van-button__text p {
  font-size: 12px;
}
.recordflag .van-button .van-button__content .van-button__text img {
  width: 30px;
  height: 30px;
}
.recorditem .recordlist {
  margin: 5px auto;
}
.recorditem .recordlist .van-radio-group {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.recorditem .recordlist .van-radio-group .van-radio {
  background: #fff;
  border: solid 1px #f2f2f2;
  padding: 3px 5px;
  border-radius: 35px;
  margin: 5px;
}
.recorditem .recordlist .van-radio-group .van-radio .van-radio__label {
  display: flex;
  align-items: center;
  color: #999;
  font-size: 14px;
}
.recorditem .recordlist .van-radio-group .van-radio .van-radio__label img {
  width: 20px;
  height: 20px;
  margin-right: 5px;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.wrapper .startbox {
  background: #fff;
  border-radius: 5px;
  padding: 5%;
}
.wrapper .startbox button {
  margin: 5px 0;
}
.block {
  width: 240px;
  height: auto;
  border-radius: 10px;
  padding: 8% 5%;
  background: url(../../assets/hearinggreenbg.jpg) repeat-y;
  border: solid 3px #fff;
  z-index: 9999;
}
.block div {
  margin-top: 10px;
}
</style>
